// The Russian strings, one file per section of the UI.
// A new section gets its file and one import line here.
import app from "./ru/app.json" with { type: "json" };
import common from "./ru/common.json" with { type: "json" };
import setup from "./ru/setup.json" with { type: "json" };
import signIn from "./ru/signIn.json" with { type: "json" };
import security from "./ru/security.json" with { type: "json" };
import projects from "./ru/projects.json" with { type: "json" };
import catalogue from "./ru/catalogue.json" with { type: "json" };
import live from "./ru/live.json" with { type: "json" };
import pwa from "./ru/pwa.json" with { type: "json" };
import help from "./ru/help.json" with { type: "json" };
import nav from "./ru/nav.json" with { type: "json" };
import table from "./ru/table.json" with { type: "json" };
import danger from "./ru/danger.json" with { type: "json" };
import connection from "./ru/connection.json" with { type: "json" };
import overview from "./ru/overview.json" with { type: "json" };
import errors from "./ru/errors.json" with { type: "json" };
import sshKeys from "./ru/sshKeys.json" with { type: "json" };
import servers from "./ru/servers.json" with { type: "json" };
import serverCreate from "./ru/serverCreate.json" with { type: "json" };
import publicIps from "./ru/publicIps.json" with { type: "json" };
import networks from "./ru/networks.json" with { type: "json" };
import firewalls from "./ru/firewalls.json" with { type: "json" };
import serverConsole from "./ru/console.json" with { type: "json" };
import images from "./ru/images.json" with { type: "json" };
import dashboard from "./ru/dashboard.json" with { type: "json" };
import volumes from "./ru/volumes.json" with { type: "json" };
import floatingIps from "./ru/floatingIps.json" with { type: "json" };
import placementGroups from "./ru/placementGroups.json" with { type: "json" };
import loadBalancers from "./ru/loadBalancers.json" with { type: "json" };
import certificates from "./ru/certificates.json" with { type: "json" };
import users from "./ru/users.json" with { type: "json" };
import access from "./ru/access.json" with { type: "json" };
import invite from "./ru/invite.json" with { type: "json" };
import autopilot from "./ru/autopilot.json" with { type: "json" };
import terminal from "./ru/terminal.json" with { type: "json" };
import rdp from "./ru/rdp.json" with { type: "json" };
import sessions from "./ru/sessions.json" with { type: "json" };
import apiAccess from "./ru/apiAccess.json" with { type: "json" };
import oauth from "./ru/oauth.json" with { type: "json" };
import costs from "./ru/costs.json" with { type: "json" };
import budgets from "./ru/budgets.json" with { type: "json" };
import notifications from "./ru/notifications.json" with { type: "json" };
import alerts from "./ru/alerts.json" with { type: "json" };
import monitoring from "./ru/monitoring.json" with { type: "json" };
import assistant from "./ru/assistant.json" with { type: "json" };
import packages from "./ru/packages.json" with { type: "json" };

export const ru = {
  app,
  common,
  setup,
  signIn,
  security,
  projects,
  catalogue,
  live,
  pwa,
  help,
  nav,
  table,
  danger,
  connection,
  overview,
  errors,
  sshKeys,
  servers,
  serverCreate,
  publicIps,
  networks,
  firewalls,
  console: serverConsole,
  images,
  dashboard,
  volumes,
  floatingIps,
  placementGroups,
  loadBalancers,
  certificates,
  users,
  access,
  invite,
  autopilot,
  terminal,
  rdp,
  sessions,
  apiAccess,
  oauth,
  costs,
  budgets,
  notifications,
  alerts,
  monitoring,
  assistant,
  packages,
};
